module.exports = __webpack_public_path__ + "static/media/laas.68599a4f.mp3";